import { keyBy, map, property } from "lodash";

import { CRUDAction, IEntityFetchCollectionSuccess, RequestAction } from "store/entities/actions";

import { CANNED_RESPONSE, CannedResponseAction, CannedResponseActionNames } from "./actions";
import { groupCannedResponsesIdsByShortcuts, mergeIdsByShortcuts, removeIdFromIdsByShortcuts } from "./helpers";
import {
  ICannedResponse,
  ICannedResponsesState,
  ICreateCannedResponseSuccessPayload,
  IDeleteCannedResponseAttachmentPayload,
  IDeleteCannedResponseSuccessPayload,
  IFetchSingleSuccessPayload,
} from "./interfaces";

const initialState: ICannedResponsesState = {
  allIds: [],
  byIds: {},
  idsByShortcuts: {},
};

export const cannedResponsesReducer = (
  state: ICannedResponsesState = initialState,
  action: CannedResponseAction
): ICannedResponsesState => {
  switch (action.type) {
    case CANNED_RESPONSE[CRUDAction.FETCH_SINGLE][RequestAction.SUCCESS]: {
      const { value: cannedResponse } = action.payload as IFetchSingleSuccessPayload;
      return {
        ...state,
        allIds: state.allIds.concat([cannedResponse.id]),
        byIds: {
          ...state.byIds,
          [cannedResponse.id]: {
            ...state.byIds[cannedResponse.id],
            ...cannedResponse,
          },
        },
        idsByShortcuts: mergeIdsByShortcuts(state.idsByShortcuts, cannedResponse),
      };
    }

    case CANNED_RESPONSE[CRUDAction.FETCH_COLLECTION][RequestAction.SUCCESS]: {
      const { values: cannedResponses } = action.payload as IEntityFetchCollectionSuccess<ICannedResponse>;
      return {
        allIds: map(cannedResponses, property("id")),
        byIds: keyBy(cannedResponses, v => v.id),
        idsByShortcuts: groupCannedResponsesIdsByShortcuts(cannedResponses),
      };
    }

    case CANNED_RESPONSE[CRUDAction.CREATE][RequestAction.SUCCESS]:
    case CANNED_RESPONSE[CRUDAction.UPDATE][RequestAction.SUCCESS]:
    case CannedResponseActionNames.SYNC_PATCH: {
      const { value: cannedResponse } = action.payload as ICreateCannedResponseSuccessPayload;

      return {
        ...state,
        // @ts-expect-error TS(2532): Object is possibly 'undefined'.
        allIds: state.allIds.concat([cannedResponse.id]),
        byIds: {
          ...state.byIds,
          // @ts-expect-error TS(2532): Object is possibly 'undefined'.
          [cannedResponse.id]: {
            // @ts-expect-error TS(2532): Object is possibly 'undefined'.
            ...state.byIds[cannedResponse.id],
            ...cannedResponse,
          },
        },
        // @ts-expect-error TS(2345): Argument of type 'ICannedResponse | undefined' is ... Remove this comment to see the full error message
        idsByShortcuts: mergeIdsByShortcuts(state.idsByShortcuts, cannedResponse),
      };
    }

    case CANNED_RESPONSE[CRUDAction.DELETE][RequestAction.SUCCESS]:
    case CannedResponseActionNames.SYNC_DELETE: {
      const { id } = action.payload as IDeleteCannedResponseSuccessPayload;
      // FIXME: Fix this the next time the file is edited.
      // @ts-expect-error TS(2464): A computed property name must be of type 'string',... Remove this comment to see the full error message
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { [id]: _, ...rest } = state.byIds;

      return {
        ...state,
        allIds: state.allIds.filter(i => i !== id),
        byIds: rest,
        // @ts-expect-error TS(2345): Argument of type 'string | undefined' is not assig... Remove this comment to see the full error message
        idsByShortcuts: removeIdFromIdsByShortcuts(state.idsByShortcuts, id),
      };
    }

    case CannedResponseActionNames.REMOVE_ATTACHMENT: {
      const { id, attachmentIndex } = action.payload as IDeleteCannedResponseAttachmentPayload;

      return {
        ...state,
        byIds: {
          ...state.byIds,
          // @ts-expect-error TS(2464): A computed property name must be of type 'string',... Remove this comment to see the full error message
          [id]: {
            // @ts-expect-error TS(2538): Type 'undefined' cannot be used as an index type.
            ...state.byIds[id],
            // @ts-expect-error TS(2538): Type 'undefined' cannot be used as an index type.
            // FIXME: Fix this the next time the file is edited.
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            attachments: state.byIds[id].attachments.filter((_: any, i: any) => i !== attachmentIndex),
          },
        },
      };
    }

    default:
      return state;
  }
};
